export default {
  computed: {
    pathMixin_isMeeting() {
      return Boolean(
        this.$route.path.match(/(^\/meetings(?:\/((?:[^/]+?)))?(?:\/(?=$))?$)/)
      );
    },
    pathMixin_isMeetingLandingPage() {
      // Check if the current path is "/select-event-demo" or starts with "/meet/"
      return this.$route.path === "/select-event-demo" || this.$route.path.startsWith("/meet/");
  },
  

    pathMixin_isBookingPage(){
      return Boolean(
          this.$route.path.match(/(^\/search(?:\/((?:[^/]+?)))?(?:\/(?=$))?$)/)
      );
    },

    pathMixin_isBookingPageWithoutTravelerBar(){
      return Boolean(
          this.$route.path.match(/(^\/search(?:\/((?:[^/]+?)))?(?:\/(?=$))?$)/)
          && this.$route.path !== "/search"
          && this.$route.path !== "/search/"
      );
    }
  },
};
